
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { DataRoomProvider } from '../../context/DataRoomContext';
import CompanyDocuments from './CompanyDocuments';
import DocumentList from './DocumentList';
import DocumentChecklistSidebar from './DocumentChecklistSidebar';
import { useDocumentChecklist } from '../../hooks/useDocumentChecklist';
import { CheckSquare } from 'lucide-react';

const DataRoomContent: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { progress } = useDocumentChecklist();
  
  const pendingCount = progress.totalRequired - progress.completed;

  return (
    <div className="min-h-screen bg-gradient-to-br from-dataroom-primary-lighter to-white">
      <div className="flex">
        {/* Main Content */}
        <div className="flex-1">
          <div className="bg-white flex flex-col rounded-[10px] p-0">
            {/* <div className="flex items-center border-b border-dataroom-primary/30 pb-4 mb-6">
              <div className="flex-1 flex space-x-10">
                <a href="#" className="text-gray-500 flex items-center gap-2 hover:text-dataroom-primary transition-colors">
                  <span className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center text-sm text-gray-600">C</span>
                  <span>Company Profile</span>
                </a>
                <a href="#" className="text-dataroom-primary font-medium border-b-2 border-dataroom-primary pb-4 flex items-center gap-2">
                  <span className="w-5 h-5 bg-dataroom-primary-light rounded flex items-center justify-center">
                    <span className="w-3 h-3 bg-dataroom-primary rounded"></span>
                  </span>
                  <span>Data Room</span>
                </a>
                <a href="#" className="text-gray-500 flex items-center gap-2 hover:text-dataroom-primary transition-colors">
                  <span className="w-5 h-5 bg-gray-100 rounded flex items-center justify-center text-gray-500">A</span>
                  <span>Asset Details</span>
                </a>
                <a href="#" className="text-gray-500 flex items-center gap-2 hover:text-dataroom-primary transition-colors">
                  <span className="w-5 h-5 bg-gray-100 rounded flex items-center justify-center text-gray-500">R</span>
                  <span>Requirements</span>
                </a>
              </div>
              <div>
                <a href="#" className="text-dataroom-primary flex items-center gap-2 hover:opacity-80 transition-opacity">
                  <span className="w-5 h-5 bg-dataroom-primary-light rounded-full flex items-center justify-center text-dataroom-primary">A</span>
                  <span>Activity Log</span>
                </a>
              </div>
            </div> */}
            
            <Tabs defaultValue="upload" className="space-y-6">
              <TabsList className="bg-dataroom-primary-light">
                {/* <TabsTrigger value="checklist" className="data-[state=active]:bg-dataroom-primary data-[state=active]:text-white">Document Checklist</TabsTrigger> */}
                <TabsTrigger value="upload" className="data-[state=active]:bg-dataroom-primary data-[state=active]:text-white">Document Upload</TabsTrigger>
                <TabsTrigger value="browse" className="data-[state=active]:bg-dataroom-primary data-[state=active]:text-white">Document Browser</TabsTrigger>
              </TabsList>
              
              {/* <TabsContent value="checklist">
                <DocumentChecklist />
              </TabsContent> */}
              
              <TabsContent value="upload" className="space-y-8">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-xl font-bold mb-2 text-gray-800">Upload Documents</h2>
                    <p className="text-sm text-gray-600">Upload your company documents to complete the checklist</p>
                  </div>
                  
                  <Button
                    onClick={() => setIsSidebarOpen(true)}
                    className="bg-dataroom-primary hover:bg-dataroom-primary/90 text-white flex items-center gap-2"
                  >
                    <CheckSquare className="h-4 w-4" />
                    Document Checklist
                    {pendingCount > 0 && (
                      <Badge variant="secondary" className="ml-2 bg-red-100 text-red-700">
                        {pendingCount} pending
                      </Badge>
                    )}
                  </Button>
                </div>
                
                <CompanyDocuments />
              </TabsContent>
              
              <TabsContent value="browse">
                <DocumentList />
              </TabsContent>
            </Tabs>
          </div>
        </div>
        
        {/* Right Sidebar */}
        <DocumentChecklistSidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />
      </div>
      
      {/* Backdrop */}
      {isSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/20 z-40"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}
    </div>
  );
};

const DataRoom: React.FC = () => {
  return (
    <DataRoomProvider>
      <DataRoomContent />
    </DataRoomProvider>
  );
};

export default DataRoom;
